import { render, staticRenderFns } from "./PhysicalNodes.vue?vue&type=template&id=e2b696e4"
import script from "./PhysicalNodes.vue?vue&type=script&lang=ts"
export * from "./PhysicalNodes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports